var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-logo",style:({'--diameter': _vm.diameter})},[(_vm.logo)?_c('img',{staticClass:"space-logo__image",attrs:{"src":_vm.image},on:{"load":_vm.setImageSize}}):_c('div',{staticClass:"space-logo__initials"},[_vm._v(_vm._s(_vm.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }